
export enum ShipperCustomerTypeCd {
	CUSTOMER = 'Customer',
	FUTURE = 'Future'}
